// FIXME move to j-react-components + display error if dev mode
export const Empty = () => <></>;
